import { takeEvery, put, call } from 'redux-saga/effects';
import { Creators, Types } from 'src/store/redux/statistics-tpa/actions';
import statisticsAPI from 'src/services/api/statistics';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* getFrq(filters: any = null) {
  try {
    // @ts-ignore: Unreachable code error
   
    const response = yield call(statisticsAPI.frqSection, filters);
    yield put(
      Creators.statisticsFrqRequestSuccess(response.data)
    );
  } catch (e) {
    let error = e;
    DBErrorMonitor.captureException(e, {
      saga: 'getFrquency',
      entity: 'statistics',
    });
    handleErrorResponse(error);
    yield put(Creators.statisticsFrqRequestError(error));
  }
}

export function* watchGetFrequency() {
  yield takeEvery(
    Types.STATISTICS_FRQ_REQUEST,
    getFrq
  );
}

export default watchGetFrequency;
